import type { Kontext } from '@famecreator/shared-types/kontext';
import { create } from 'zustand';

type DeleteConfirmationStore = {
  isOpen: boolean;
  kontextToDelete: Kontext | null;
  onConfirm: (() => void) | null;
  openDeleteModal: (kontext: Kontext, onConfirm: () => void) => void;
  closeDeleteModal: () => void;
  confirmDelete: () => void;
};

export const useDeleteConfirmationStore = create<DeleteConfirmationStore>((set, get) => ({
  isOpen: false,
  kontextToDelete: null,
  onConfirm: null,

  openDeleteModal: (kontext, onConfirm) => {
    set({
      isOpen: true,
      kontextToDelete: kontext,
      onConfirm,
    });
  },

  closeDeleteModal: () => {
    set({
      isOpen: false,
      kontextToDelete: null,
      onConfirm: null,
    });
  },

  confirmDelete: () => {
    const { onConfirm } = get();
    if (onConfirm) {
      onConfirm();
    }
    get().closeDeleteModal();
  },
}));
